import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 1000"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M93.8 990s127.6-378.9 492.5-769.5c0 0 7.5-33.4-46 16.8S287.8 459.1 158 730c0 0-116.1-374 243-583.2 0 0-6.8 45 10.7 102.8 0 0 87.2-235.5 394.9-239.6 0 0 133.6-5.6 91.2 112.2-42.4 117.7-196.2 180.9-196.2 180.9s50.2 13.5 131.2-7.8c0 0-18.9 222.1-349.5 244 0 0 43.1 20.9 202.6 13.9 0 0-93.7 243-450.8 287.5-.1 0-19.2 139.7-141.3 149.3" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "feather"}) } }